var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7231 14.2477L4.03594 15.9348M3.85964 9.74825H1.47363M4.03594 3.56279L5.7231 5.24988M10.2227 1L10.2227 3.38591M16.4085 3.56279L14.7213 5.24988M22.074 19.4658L20.212 21.3279C20.0063 21.5336 19.6728 21.5336 19.4671 21.3279L16.5315 18.3923C16.3096 18.1703 15.9439 18.1906 15.7478 18.4357L13.7735 20.9036C13.5063 21.2376 12.9734 21.1306 12.8559 20.7193L9.67248 9.57746C9.55897 9.18016 9.92628 8.81285 10.3236 8.92637L21.4654 12.1097C21.8767 12.2273 21.9837 12.7602 21.6497 13.0274L19.1818 15.0017C18.9367 15.1978 18.9164 15.5634 19.1384 15.7854L22.074 18.721C22.2797 18.9267 22.2797 19.2602 22.074 19.4658Z",
    stroke: "#825DFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClick);
export default __webpack_public_path__ + "static/media/click.6034f7243ccf0ce13fa7eb17833c65e8.svg";
export { ForwardRef as ReactComponent };